<template>
	<select @change='change' :id="id"v-model="selected" class='form-control my-control' :class='field_class' data-num='f_9' data-table='1' :disabled='disabled'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const FORESTRY = 'forestrie_list.php'
	const HEADER = 'get_header.php'

	import {EventBus} from '../../../lib/EventBus'
	
	export default {
		name: 'forestry',
		data: function () { 
			return {
				selected: '0',
				options: [],
				id: `${this.type}_forestry`
			}
		},
		props: {
			type: '',
			reg_id: '',
			f_id: '',
			field_class: '',
			disabled: ''
		},
		methods: {
			fill: function (id) {
				//console.log(id)
				fetch(DB + FORESTRY + '?id=' + id)
				.then(data => data.json())
				.then(data => {
					if (data) {
						// this.selected = select ? select : '0'
						this.options = [{id: '0', name: ''}, ...data];
						this.selected = this.f_id ? this.f_id : '0'
						EventBus.$emit('init_forestry_correct', this.selected)
					}
					else {
						this.selected = '0'
						this.options = []
					}
				})
				.then(() => {
					if (this.disabled) {
						document.getElementById('btnAddLine').disabled = true
						document.getElementById('btnCopyLine').disabled = true
						document.getElementById('btnDeleteLine').disabled = true
					}
					else {
						document.getElementById('btnAddLine').disabled = this.selected === '0'
						document.getElementById('btnCopyLine').disabled = this.selected === '0'
						document.getElementById('btnDeleteLine').disabled = this.selected === '0'
					}
				})
				.catch(err => console.log(err))
			},
			change: function () {
				document.getElementById('btnAddLine').disabled = this.selected === '0'
				document.getElementById('btnCopyLine').disabled = this.selected === '0'
				document.getElementById('btnDeleteLine').disabled = this.selected === '0'

				this.$parent.data_location.localforestry = null
				EventBus.$emit(`${this.type}_forestry`, this.selected)
			}
		},
		created () {
			EventBus.$on(`${this.type}_region`, id => {
				this.fill(id)
			})
		},
		watch: {
			reg_id (id) {
				if (typeof id !== 'undefined' && id !== null) {
					this.fill(id)
				}
			}
		},
		beforeDestroy () {
			EventBus.$off(`${this.type}_region`)
		}
	}
</script>


// WEBPACK FOOTER //
// forestry.vue?e16df948